import Widget from '@/api/widget'

export default {
  namespaced: true,
  state: {
    jobs: [],
    companies: [],
    jobLoading: true,
    companiesLoading: true,
    companyLoader: false,
    jobLoader: false,
    activeTab: 'Jobs',
    jobBoardId: '',
    talents: [],
    talentLoading: false,
    page: 1,
    size: 30,
    companyPage: 1,
    companySize: 30,
    jobPage: 1,
    jobSize: 30,
    filters: {
      keyword: '',
      locations: '',
      jobType: '',
      salaryRange: '',
      jobCategory: ''
    },
    totalJobs: 0,
    totalCompanies: 0,
    totalTalent: 0,
    activeJobNav: 'search_jobs',
    firstName: '',
    lastName: '',
    email: '',
    optIn: false,
    cv: null,
    firstNameError: null,
    lastNameError: null,
    emailError: null,
    cvError: null,
    captcha: null,
    selectedJobId: null,
    jobFormLoading: false,
    formSubmit: false,
    jobError: null,
    jobException: null,
    jobMessage: '',
    talentFilters: {
      contractTypes: [],
      keyword: '',
      locations: ''
    },
    companiesFilters: {
      keyword: '', locations: '', jobType: ''
    }
  },
  getters: {
    jobFormData (state) {
      return {
        firstName: state.firstName,
        lastName: state.lastName,
        email: state.email,
        file: state.cv,
        captcha: state.captcha,
        jobId: state.selectedJobId
      }
    }
  },
  mutations: {
    setCompaniesFilters (state, filters) {
      state.companies = []
      state.companiesFilters = {...filters}
    },
    setTalentFilters (state, filters) {
      state.talents = []
      state.talentFilters = {...filters}
    },
    setJobs (state, jobs) {
      state.jobs = [...state.jobs, ...jobs]
    },
    setJobsFilter (state, jobs) {
      state.jobs = jobs
    },
    setCompanies (state, companies) {
      state.companies = [...state.companies, ...companies]
    },
    setJobLoading (state, loading) {
      state.jobLoading = loading
    },
    setCompaniesLoading (state, loading) {
      state.companiesLoading = loading
    },
    setActiveTab (state, activeTab) {
      state.activeTab = activeTab
    },
    setJobBoardId (state, jobBoardId) {
      state.jobBoardId = jobBoardId
    },
    setTalentLoading (state, talentLoading) {
      state.talentLoading = talentLoading
    },
    setTalents (state, talents) {
      state.talents = [...state.talents, ...talents]
    },
    setPage (state) {
      state.page = state.page + 1
    },
    resetCompanyTalentPage (state) {
      state.page = 1
      state.companyPage = 1
    },
    setCompanyPage (state) {
      state.companyPage = state.companyPage + 1
    },
    setJobPage (state) {
      state.jobPage = state.jobPage + 1
    },
    setFilters (state, {keyword, locations, jobType, salaryRange, jobCategory}) {
      state.filters.keyword = keyword
      state.filters.locations = locations
      state.filters.jobType = jobType
      state.filters.salaryRange = salaryRange
      state.filters.jobCategory = jobCategory
    },
    setCompanyLoader (state, companyLoader) {
      state.companyLoader = companyLoader
    },
    setJobLoader (state, jobLoader) {
      state.jobLoader = jobLoader
    },
    setTotalJobs (state, totalJobs) {
      state.totalJobs = totalJobs
    },
    setTotalCompanies (state, totalCompanies) {
      state.totalCompanies = totalCompanies
    },
    setTotalTalent (state, totalTalent) {
      state.totalTalent = totalTalent
    },
    resetJobPage (state) {
      state.jobPage = 1
    },
    setActiveJobNav (state, activeJobNav) {
      state.activeJobNav = activeJobNav
    },
    resetWidgetJobForm (state) {
      state.firstName = ''
      state.lastName = ''
      state.email = ''
      state.cv = null
      state.optIn = false
      state.captcha = null
      state.selectedJobId = null
    },
    setFirstName (state, firstName) {
      if (firstName.length > 0) {
        state.firstNameError = null
      }
      state.firstName = firstName
    },
    setLastName (state, lastName) {
      if (lastName.length > 0) {
        state.lastNameError = null
      }
      state.lastName = lastName
    },
    setEmail (state, email) {
      if (email.length > 0) {
        state.emailError = null
      }
      state.email = email
    },
    setCv (state, cv) {
      if (cv) {
        state.cvError = null
      }
      state.cv = cv
    },
    setOptIn (state, optIn) {
      state.optIn = optIn
    },
    setFirstNameError (state, firstNameError) {
      state.firstNameError = firstNameError
    },
    setLastNameError (state, lastNameError) {
      state.lastNameError = lastNameError
    },
    setEmailError (state, emailError) {
      state.emailError = emailError
    },
    setCvError (state, cvError) {
      state.cvError = cvError
    },
    setCaptcha (state, captcha) {
      state.captcha = captcha
    },
    setSelectedJobId (state, selectedJobId) {
      state.selectedJobId = selectedJobId
    },
    setJobFormLoading (state, jobFormLoading) {
      state.jobFormLoading = jobFormLoading
    },
    setFormSubmit (state, formSubmit) {
      state.formSubmit = formSubmit
    },
    setJobError (state, jobError) {
      state.jobError = jobError
    },
    setJobException (state, jobException) {
      state.jobException = jobException
    },
    setJobMessage (state, jobMessage) {
      state.jobMessage = jobMessage
    }
  },
  actions: {
    async getWidgetJobs ({ commit, state }) {
      const {keyword, locations} = state.filters
      commit('setJobLoader', true); commit('setJobLoading', true)
      const jobs = await Widget.getWidgetJobs({ keyword, locations }, state.jobBoardId, state.jobPage, state.jobSize)
      commit('setJobs', jobs.data)
      commit('setTotalJobs', jobs.total)
      commit('setJobLoader', false); commit('setJobLoading', false)
    },
    async getWidgetCompanies ({ commit, state }) {
      const {keyword = '', locations = '', jobType = ''} = state.companiesFilters
      commit('setCompanyLoader', true); commit('setCompaniesLoading', true)
      const companies = await Widget.getWidgetCompanies({ keyword, location: locations, jobType }, state.jobBoardId, state.companyPage, state.companySize)
      commit('setCompanies', companies.data)
      commit('setTotalCompanies', companies.total)
      commit('setCompanyLoader', false); commit('setCompaniesLoading', false)
    },
    async search ({commit, state}) {
      commit('setJobLoader', true); commit('setJobLoading', true)
      commit('resetJobPage')
      const {keyword, locations, jobType, salaryRange, jobCategory} = state.filters
      const jobs = await Widget.search({ keyword, locations, jobType, salaryRange, jobCategory }, state.jobBoardId, state.jobPage, state.jobSize)
      commit('setJobsFilter', jobs.data)
      commit('setTotalJobs', jobs.total)
      commit('setJobLoader', false); commit('setJobLoading', false)
    },
    async searchJobs ({commit, state}) {
      commit('setJobLoader', true); commit('setJobLoading', true)
      const {keyword, locations, jobType, salaryRange, jobCategory} = state.filters
      const jobs = await Widget.search({ keyword, locations, jobType, salaryRange, jobCategory }, state.jobBoardId, state.jobPage, state.jobSize)
      commit('setJobs', jobs.data)
      commit('setTotalJobs', jobs.total)
      commit('setJobLoader', false); commit('setJobLoading', false)
    },
    async getTalent ({commit, state}) {
      try {
        commit('setTalentLoading', true)
        const talents = await Widget.getWidgetTalents(state.jobBoardId, state.page, state.size, state.talentFilters)
        commit('setTalents', talents.data)
        commit('setTotalTalent', talents.total)
        commit('setTalentLoading', false)
      } catch (e) {
        commit('setTalentLoading', false)
        commit('setTotalTalent', 0)
        console.log('error', e)
      }
    },
    async submitJobForm ({commit, getters}) {
      try {
        commit('setJobException', null)
        commit('setJobError', null)
        commit('setJobFormLoading', true)
        const data = getters.jobFormData
        await Widget.submitJobForm(data)
        commit('setJobFormLoading', false)
        commit('setFormSubmit', true)
        commit('setJobMessage', 'To confirm your application, click the link in the email we sent to')
      } catch (e) {
        commit('setJobFormLoading', false)
        commit('setJobException', e.message.exception)
        commit('setJobError', e.message.message)
        commit('setFormSubmit', true)
      }
    },
    async resendEmail ({commit, state}) {
      try {
        commit('setJobFormLoading', true)
        const data = {
          jobId: state.selectedJobId,
          email: state.email
        }
        await Widget.resendEmail(data)
        commit('setJobFormLoading', false)
        commit('setFormSubmit', true)
        commit('setJobException', null)
        commit('setJobError', null)
        commit('setJobMessage', 'Email sent to')
      } catch (e) {
        commit('setJobFormLoading', false)
        commit('setJobException', e.message.exception)
        commit('setJobError', e.message.message)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/widget.js